import { Observable } from 'rxjs';

export class Credentials {
  private readonly _login: string;
  private readonly _password: string;

  static fromEncodedString(str: string) {
    const _ = decodeURIComponent(escape(atob(str)));
    return new Credentials(_.split(':')[0], _.split(':')[1]);
  }

  constructor(login: string, password: string) {
    this._login = login;
    this._password = password;
  }

  get asEncodedString(): string {
    return btoa(unescape(encodeURIComponent(this._login + ':' + this._password)));
  }

  get login(): string {
    return this._login;
  }
}

export abstract class CredentialsFactory {
  abstract getCredentials$(): Observable<Credentials>;
}
